import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FileService } from '@app/core/services/file.service';
import { AbstractMatTableComponent } from '@app/shared/base/abstract-mat-table/abstract-mat-table.component';

@Component({
  selector: 'app-documents-table',
  templateUrl: './documents-table.component.html',
  styleUrls: ['./documents-table.component.scss'],
})
export class DocumentsTableComponent extends AbstractMatTableComponent {
  displayedColumns: string[] = ['name', 'fileSize', 'dateUploaded', 'action'];
  @Output() downloadDocument = new EventEmitter<string>();

  constructor(
    public datePipe: DatePipe,
    public fileService: FileService
  ) {
    super();
  }

  downloadFile(documentId: string) {
    this.downloadDocument.emit(documentId);
  }
}
